import React from 'react';

interface PartnersSectionHeadingProps {
  title: React.ReactNode;
  subtitle?: string;
  align?: 'center' | 'left';
  light?: boolean;
}

const PartnersSectionHeading: React.FC<PartnersSectionHeadingProps> = ({
  title,
  subtitle,
  align = 'center',
  light = false,
}) => (
  <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-xl'}>
    <h2
      className={`font-instrument text-[2.4rem] leading-[1.05] tracking-[-0.02em] sm:text-5xl lg:text-[64px] lg:leading-[0.95] lg:tracking-[-0.025em] ${
        light ? 'text-white' : 'text-[#2a0f2a]'
      }`}
    >
      {title}
    </h2>
    {subtitle && (
      <p
        className={`mt-4 font-jakarta text-base leading-relaxed lg:text-[17px] lg:leading-[25.5px] ${
          light ? 'text-white/70' : 'text-[#5a3158]'
        }`}
      >
        {subtitle}
      </p>
    )}
  </div>
);

export default PartnersSectionHeading;
